import $ from 'jquery'

export function initialise() {
  const $menu = $('[data-mobile-menu]')

  $menu.find('> ul > li').each((_i, li) => {
    const $accordionIndicator = $(li).find('.accordion-indicator')
    const $link = $(li).find('> a')
    const $submenu = $(li).find('> ul')

    if (!$submenu.length) {
      // remove the accordion indicator if there is no submenu
      $accordionIndicator.remove()
    } else {
      // open the submenu if it's active
      if ($link.hasClass('active')) {
        $accordionIndicator.addClass('open')
        $submenu.show()
      }

      $accordionIndicator.on('click', (e) => {
        e.preventDefault()

        // toggle the accordion indicator
        $accordionIndicator.toggleClass('open')

        // open the submenu
        $submenu.slideToggle({
          complete: () => {
            // scroll the submenu into view when complete
            $submenu.parent().get(0).scrollIntoView({ block: 'end', behavior: 'smooth' })
          },
        })
      })
    }
  })
}
